import { Pagination } from "antd";
import React from "react";
import styled from "styled-components";
import { useFilters } from "../../data/useFilters";
import { useSearchResults } from "../../data/useSearchResults";

const Container = styled.div`
  justify-content: center;
  width: 100;
  display: flex;
  margin-bottom: 30px;
`;

const PAGE_PREFIX = "page";

const SearchPagination = () => {
  const { page, changePage, updatePageQuery } = useFilters();
  const { data } = useSearchResults();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const pageQuery = urlParams.get(PAGE_PREFIX);
  const currentPage = Number(pageQuery) || page;

  const onChange = (page) => {
    updatePageQuery(page);
    changePage(page);
  };

  return (
    <Container>
      {data?.meta?.pages_count > 1 && (
        <Pagination
          current={currentPage}
          defaultPageSize={24}
          onChange={onChange}
          pageSize={data?.meta?.pages_items}
          showSizeChanger={false}
          total={data?.meta?.filters_results_count ?? data?.meta?.results_count}
        />
      )}
    </Container>
  );
};

export default SearchPagination;
